import { History } from 'history';

export const navigateToScenarioPricing = (rowData: any, language: string, history: History) => {
  const route = 'pages/master-pool/master-pool-details/pricing-scenario';
  const params = new URLSearchParams(location.search);
  const masterPoolCmhcAccountNumber = params.get('masterPoolCmhcAccountNumber');

  history.push(`/${language}/${route}?masterPoolCmhcAccountNumber=${masterPoolCmhcAccountNumber}`);
};
